import React, { useState } from 'react';
import { FiLock, FiX } from 'react-icons/fi';
import { toast } from '../Toast';

interface Props {
    onClose: () => void;
}

// UI only for now: checks the two new passwords match, sends nothing. The planned POST /api/profile/password
// (current password check + strength rules) is parked in tmp/figma-impl/account-security-backend.patch.
const ChangePasswordModal: React.FC<Props> = ({ onClose }) => {
    const [current, setCurrent] = useState('');
    const [next, setNext] = useState('');
    const [confirm, setConfirm] = useState('');

    const mismatch = confirm.length > 0 && next !== confirm;
    const canSave = current.length > 0 && next.length > 0 && next === confirm;

    const save = () => {
        toast.info('Preview only: this isn’t connected yet, so your password was not changed');
        onClose();
    };

    return <div className="modal-overlay" onClick={onClose}>
        <div className="change-password-modal" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
                <span className="icon-tile"><FiLock /></span>
                <div>
                    <h2>Change Password</h2>
                    <p>Every other device will be signed out</p>
                </div>
                <button type="button" className="close" aria-label="Close" onClick={onClose}><FiX /></button>
            </div>

            <form className="modal-body" onSubmit={e => { e.preventDefault(); if (canSave) save(); }}>
                <label className="field">
                    <span className="label">Current password</span>
                    <input type="password" autoComplete="current-password" value={current} onChange={e => setCurrent(e.target.value)} autoFocus />
                </label>
                <label className="field">
                    <span className="label">New password</span>
                    <input type="password" autoComplete="new-password" value={next} onChange={e => setNext(e.target.value)} />
                </label>
                <label className="field">
                    <span className="label">Confirm new password</span>
                    <input type="password" autoComplete="new-password" value={confirm} onChange={e => setConfirm(e.target.value)} />
                </label>
                {mismatch && <p className="error">The new passwords don't match</p>}
                {/* hidden submit so Enter works */}
                <button type="submit" hidden />
            </form>

            <div className="modal-footer">
                <button type="button" className="link" onClick={onClose}>Cancel</button>
                <button type="button" className="btn-primary" onClick={save} disabled={!canSave}>Change Password</button>
            </div>
        </div>
    </div>;
};

export default ChangePasswordModal;
